// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7aa177d0","453":"f1822dd5","732":"ad81e253","977":"cdc239e7"}[chunkId] + ".chunk.js";
};